import {
  Box,
  DialogContent,
  DialogTitle,
  Typography,
  Link as MuiLink,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAuthState } from 'state/useAuthState';
import { formatTimestamp } from 'shared/dates';
import { InfoRow } from '../InfoRow';
import { FirePerimeterPoi } from './PoiDialog.types';

const useStyles = makeStyles()((theme) => ({
  title: {
    padding: theme.spacing(2, 6, 1, 2),
    lineHeight: '1 !important',
  },
  content: {
    padding: theme.spacing(0, 2, 2, 2),
    maxWidth: 375,
    lineHeight: '18px',
  },
}));

export const ActiveFirePerimeterDialogContent = (
  props: FirePerimeterPoi,
): JSX.Element => {
  const { source, dateCurrent, id } = props;
  const { classes } = useStyles();
  const { t } = useTranslation();
  const {
    permissions: { isWildfireStaffReporter },
  } = useAuthState();

  return (
    <>
      <DialogTitle id="alert-dialog-title" className={classes.title}>
        <Typography component="span" variant="body2">
          <b>{t('map.poi.activeFirePerimeters.title')}</b>
        </Typography>
      </DialogTitle>

      <DialogContent className={classes.content}>
        <InfoRow
          title={t('map.poi.activeFirePerimeters.created')}
          content={formatTimestamp(dateCurrent)}
        />

        <InfoRow
          title={t('map.poi.activeFirePerimeters.source')}
          content={source}
        />

        <InfoRow
          title={t('map.poi.activeFirePerimeters.notes.title')}
          content={t('map.poi.activeFirePerimeters.notes.content')}
        />

        {isWildfireStaffReporter && (
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ width: 96 }}>
              <Typography
                variant="h4"
                color="textSecondary"
                sx={(theme) => ({ fontSize: theme.typography.body2.fontSize })}
              >
                {t('map.poi.activeFirePerimeters.editStatus')}
              </Typography>
            </Box>
            <Box sx={{ flex: 1 }}>
              <MuiLink
                component={Link}
                to={`/fire_perimeters/${id}/edit`}
                underline="none"
                color="accent"
                variant="body2"
              >
                {t('common.edit')}
              </MuiLink>
            </Box>
          </Box>
        )}
      </DialogContent>
    </>
  );
};
